import * as React from 'react';
import cn from 'classnames';

import LoaderSpinner from 'shared/newComponents/animations/LoaderSpinner';
import {
  LoaderSpinnerColor,
  LoaderSpinnerSize
} from 'shared/newEntities/components/LoaderSpinner';
import Stub from 'shared/newComponents/Stub';
import { BaseListProps } from 'shared/newEntities/components/list';

import './BaseList.modules.scss';

const BaseList = React.forwardRef(
  (
    {
      children,
      loading,
      listLength,
      loaderSize = LoaderSpinnerSize.sm,
      className,
      scrollTargetId,
      parentScroll = false,
      stub
    }: BaseListProps,
    ref: React.MutableRefObject<HTMLDivElement>
  ) => {
    return (
      <div
        id={scrollTargetId}
        styleName={cn(
          'list',
          !listLength && 'list_empty',
          loading && 'list_loading',
          parentScroll && 'list_parent-scroll'
        )}
        className={className}
        ref={ref}
      >
        {!loading && !!listLength && children}
        {loading && (
          <LoaderSpinner size={loaderSize} color={LoaderSpinnerColor.blue} />
        )}
        {!loading && !listLength && stub && <Stub {...stub} />}
      </div>
    );
  }
);

export default React.memo(BaseList);
